/* eslint-disable */
import { css, cx, keyframes } from '@emotion/css';
import { FC } from 'react';
import * as MapGL from 'react-map-gl';
import car from './car.webp';

type Props = {
  longitude: number;
  latitude: number;
  rotation: number;
  index: number;
};

export const PulsingMarker: FC<Props> = ({
  longitude,
  latitude,
  rotation,
  index,
}) => (
  <MapGL.Marker
    longitude={longitude}
    latitude={latitude}
    rotation={rotation}
    anchor="bottom"
  >
    <div
      className={cx(
        `w-[16px] h-[16px] rounded-full hover:bg-gray-900 before:rounded-full before:bg-primary-700 hover:before:bg-gray-900 before:w-[16px] before:h-[16px] cursor-pointer relative`,
        css`
          &:before {
            content: '';
            position: absolute;
            animation-name: ${pulse};
            animation-duration: 1s;
            animation-iteration-count: infinite;
            animation-delay: ${index / 100}s;
          }
        `
      )}
    >
      <img className="absolute top-0 left-0" src={car} alt="car" />
    </div>
  </MapGL.Marker>
);

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  25% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2.5);
    opacity: 0;
  }
`;
